module.exports = __webpack_public_path__ + "static/media/startBrowser.f88d553f.png";


//////////////////
// WEBPACK FOOTER
// ./src/startBrowser.png
// module id = 540
// module chunks = 0